import { CommonSuccessResponse } from "constants/types/common";
import {
  SaleOrderParamsType,
  SalesOrderResponseType,
} from "constants/types/salesOrder";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getSalesOrderListKey = (params?: SaleOrderParamsType) => {
  return `/sale-order?${serialize({ ...params })}`;
};

export const useSalesOrders = (params?: SaleOrderParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<SalesOrderResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getSalesOrderListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const salesOrders = data?.data;

  return {
    salesOrders,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const useSalesOrderDetail = (id: string | undefined) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<SalesOrderResponseType> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(id ? `/sale-order/${id}` : null, {
    refreshInterval: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    salesOrder: data?.data,
    error,
    isLoading,
    mutate,
  };
};
